import { Component, State, h } from "@stencil/core";


@Component({
  tag: "app-prices",
  styleUrl: "app-prices.css"
})
export class AppPrices {
  render() {
    return (
      <div id="prices" class="block-container prices-container">
        <h2 class="center-title">Preço que cabe no bolso</h2>

        <ion-grid>
          <ion-row class="ion-justify-content-center">
            <div class="prices-block">
              <ion-grid>
                <ion-col>
                  <ion-row class="ion-justify-content-center ion-wrap price-row">
                    <ion-card class="price-card">
                      <ion-card-header><ion-text color="dark"><h1>R$ 99,00</h1></ion-text></ion-card-header>
                      <ion-card-subtitle>Por mês</ion-card-subtitle>
                    </ion-card>
                    {/* <ion-card class="price-card">
                      <ion-card-header><ion-text color="dark"><h1>R$ 30,00</h1></ion-text></ion-card-header>
                      <ion-card-subtitle>Por profissional / por mês</ion-card-subtitle>
                    </ion-card> */}
                  </ion-row>
                </ion-col>
              </ion-grid>
            </div>
          </ion-row>
        </ion-grid>


      </div>
    );
  }
}